import React from 'react';
import SubHeader from '../../components/Layout/SubHeader';
import strings from '../../components/Language';

class FaqScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
        }
    }

    async componentDidMount() {
    }

    render() {
        return (
            <>
                <SubHeader data={{ title: strings["faqText"] }} />

                <div className='faqScreen'>
                    <main className="align-container">
                        <div className="faq-container">
                            <div className="faq-content">
                                <h2 id="faq1">{strings["faq1"]}</h2>
                                <p id="faq11">
                                    {strings["faq11"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq2">{strings["faq2"]}</h2>
                                <p id="faq22">
                                    {strings["faq22"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq3">{strings["faq3"]}</h2>
                                <p id="faq33">
                                    {strings["faq33"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq4">{strings["faq4"]}</h2>
                                <p id="faq44">
                                    {strings["faq44"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq5">{strings["faq5"]}</h2>
                                <p id="faq55">
                                    {strings["faq55"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq6">{strings["faq6"]}</h2>
                                <p id="faq66">
                                    {strings["faq66"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq7">{strings["faq7"]}</h2>
                                <p id="faq77">
                                    {strings["faq77"]}
                                </p>
                            </div>

                            <div className="faq-content">
                                <h2 id="faq8">{strings["faq8"]}</h2>
                                <p id="faq88">
                                    {strings["faq88"]}
                                </p>
                            </div>
                        </div>
                    </main>
                </div>
            </>
        );
    }
}

export default FaqScreen;
